module.exports = __webpack_public_path__ + "static/fun-time/games/page003_game1/audio//true.mp3";